<template>
    <div class="my-auto">
        <div v-if="isTable" class="mt-4">
            <TicketTable :color="color">
                <template #header><div class="row d-flex px-4 py-2 justify-content-between align-items-center">
                    <div class="d-flex">
                        <h1 class="mb-0">{{$t('support.tickets.all')}}</h1>
                    </div>
                    <div class="d-flex">
                        <a class="btn btn-success" :href="`/app/tickets/create`" role="button">
                            {{$t('support.tickets.create')}}
                        </a>
                    </div>
                </div></template>
            </TicketTable>
        </div>
        <div class="mt-4" v-else>
            <div class="container-fluid">
               <div class="row d-flex px-4 py-2 justify-content-between align-items-center">
                    <div class="d-flex">
                        <h1>{{$t('support.tickets.all')}}</h1>
                    </div>
                    <div class="d-flex">
                        <a class="btn btn-success" :href="`/app/tickets/create`" role="button">
                            {{$t('support.tickets.create')}}
                        </a>
                    </div>
                </div>
                <TicketMobile
                    v-for="ticket in tickets"
                    :key="ticket.id"
                    :ticket="ticket" />
            </div>
        </div>
    </div>
</template>

<script>
import TicketMobile from '../components/TicketComponents/TicketMobile';
import TicketTable from '../components/TicketComponents/TicketTable';
import TicketItem from '../components/TicketComponents/TicketItem';

export default {
    name: 'Tickets',
    components: {
        TicketMobile,
        TicketTable,
        TicketItem,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tickets: [],
            perPage: 0,
            column: null,
            order: 'DESC',
            filters: [],
        };
    },
    watch: {
        isTable(value) {
            if (!value) {
                this.getTickets();
            }
        },
    },
    mounted() {
        if (!this.isTable) {
            this.getTickets();
        }
    },
    methods: {
        getTickets() {
            this.$loading.show();
            window.axios
                .get('/api/app/tickets', {
                    params: {
                        per_page: this.perPage,
                        page: this.meta ? this.meta.current_page : 1,
                        column: this.column,
                        order: this.order,
                        filters: this.filters,
                    },
                })
                .then((res) => {
                    this.tickets = res.data.data;
                })
                .catch(err => console.error(err))
                .finally(() => this.$loading.close());
        },
    },
    computed: {
        isTable() {
            return this.$mq === 'lg';
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
    },
};
</script>

<style>

</style>
